import { render, staticRenderFns } from "./Lgx179903403193794560.vue?vue&type=template&id=681bacd0&scoped=true&"
import script from "./Lgx179903403193794560.vue?vue&type=script&lang=js&"
export * from "./Lgx179903403193794560.vue?vue&type=script&lang=js&"
import style0 from "./Lgx179903403193794560.vue?vue&type=style&index=0&id=681bacd0&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "681bacd0",
  null
  
)

export default component.exports